
export const Types = {
    OPEN_ADD_HOMEPAGE_ITEM_MODAL: "START_OPEN_ADD_HOMEPAGE_ITEM_MODAL",
    CLOSE_ADD_HOMEPAGE_ITEM_MODAL: "CLOSE_ADD_HOMEPAGE_ITEM_MODAL",
    SUBMIT_ADD_HOMEPAGE_ITEM_MODAL: "SUBMIT_ADD_HOMEPAGE_ITEM_MODAL"
};

export const openAddHomepageItemModal = (columnId, sectionId) => ({
    type: Types.OPEN_ADD_HOMEPAGE_ITEM_MODAL,
    columnId: columnId,
    sectionId: sectionId
});

export const closeAddHomepageItemModal = () => ({
  type: Types.CLOSE_ADD_HOMEPAGE_ITEM_MODAL
});

export const submitAddHomepageItemModal = (data) => ({
  type: Types.SUBMIT_ADD_HOMEPAGE_ITEM_MODAL,
  data: data
});



// WEBPACK FOOTER //
// ./public/components/homepage-layouts/items/AddItemModal/actions.js